export enum ScreensLocationFilterName {
  ScreenBy = 'screenBy',
  ListingLocation = 'LocationScreenListingLocation',
}
